const EyeIcon = () => {
    return (
        <svg width="24px" height="15px" viewBox="0 0 24 15" version="1.1" xmlns="http://www.w3.org/2000/svg" >
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatThreadRichLinks1920Copy2" transform="translate(-832, -567)" stroke="#6C7275" strokeWidth="2">
                    <g id="Group12Copy" transform="translate(738, 567)">
                        <g id="Group5" transform="translate(95, 1)">
                            <path d="M20.5728717,5.066 C21.4518717,5.957 21.4118717,7.399 20.4738717,8.228 C18.4918717,9.979 14.8138717,12.61 10.6028717,12.61 C6.39287174,12.61 2.71387174,9.979 0.73187174,8.228 C-0.20612826,7.399 -0.24612826,5.957 0.63287174,5.066 C2.58987174,3.083 6.32187174,0 10.6028717,0 C14.8838717,0 18.6158717,3.083 20.5728717,5.066 Z" id="Stroke1"></path>
                            <path d="M13.2298717,5.8535 C13.5288717,7.6765 11.9748717,9.2315 10.1518717,8.9325 C9.04687174,8.7515 8.15687174,7.8605 7.97587174,6.7565 C7.67687174,4.9335 9.23087174,3.3795 11.0538717,3.6775 C12.1578717,3.8585 13.0488717,4.7495 13.2298717,5.8535 Z" id="Stroke3"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default EyeIcon;
